import MenuBar from "../MenuBar/MenuBar";

export default function Links() {
    return (
        <>
            <text>Links</text>
            <MenuBar page={"/home"}/>
        </>
    )
}